<template>
  <div id="bind-product-modal">
    <el-dialog title="重新绑定商品" v-model="showModal" custom-class="bind-product" @close="bindModalClose">
      <el-form>
      <el-form-item label="绑定商品" :class="{'has-error': errmsg }">
        <el-select
          class="producr-select"
          v-model="selectedProductId"
          filterable
          remote
          placeholder="请输入商品编号或商品名称"
          :remote-method="searchProduct"
          :loading="loading"
          @change="changeProduct">
          <el-option
            v-for="item in productList"
            :key="item.visa_product_id"
            :label="'【' + item.visa_product_id + '】' + item.product_name"
            :value="item.visa_product_id">
          </el-option>
        </el-select>
      </el-form-item>
      </el-form>
      <div class="err-tips">{{errmsg}}</div>
      <el-button type="primary" @click="bindProduct" :disabled="!!errmsg || !this.selectedProductId" class="save-button">确定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/libs/utils';
import Http from '@/libs/http';

export default {
  name: 'bind-product',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    // 是否打开
    value: {
      type: Boolean,
      required: true,
      default: false,
    },

    oid: {
      type: String,
      required: true,
      default: '',
    },
    
  },
  data() {
    return {
      loading: false, // 选项加载状态
      showModal: this.value, // 是否展示
      selectedProductId: '', // 选中商品id
      productList: [], // 商品列表
      errmsg: '', // 错误提示
    };
  },
  methods: {

    // 关闭
    bindModalClose() {
      this.reset();
      this.$emit('input', false);
    },

    // 查询商品列表
    searchProduct(query) {
      if (query !== '') {
        this.loading = true;
        Http.post('/visa_product_search', { keyword: query }).then((data) => {
          this.productList = data.product;
          this.loading = false;
        }).catch((e) => {
          if (e) console.log(e);
          this.productList = [];
        });
      } else {
        this.productList = [];
      }
    },

    // 选中商品时验证是否合规
    changeProduct(id) {
      if (!id) {
        return;
      }
      Http.post('/ota_order_product_detect', { ota_sub_order_id: this.oid, visa_product_id: id }, { noToast: true }).then(() => {
        this.errmsg = '';
      }).catch((e) => {
        if (e) console.log(e);
        this.errmsg = e.msg;
      });
    },

    // 提交
    bindProduct() {
      if (this.errmsg || !this.selectedProductId) {
        return;
      }
      Http.post('/ota_order_product_bind', { ota_sub_order_id: this.oid, visa_product_id: this.selectedProductId }).then(() => {
        this.$emit('input', false);
        this.$emit('bindSuccess');
        this.reset();
        utils.msg.success('绑定成功');
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    reset() {
      this.selectedProductId = '';
      this.productList = [];
      this.errmsg = '';
    },
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
    },
  },
};
</script>

<style lang="less" scoped>
.err-tips {
  color: #ff5a60;
  margin-top: -20px;
  margin-left: 80px;
  height: 16px;
}

.save-button {
  margin:  20px auto 0;
  display: block;
  width: 240px;
}
#bind-product-modal{
/deep/ .bind-product {
  width: 600px;
  top: 50% !important;
  transform: translate(-50%, -50%);
  .el-dialog__header {
    padding: 20px;
    border-bottom: 1px solid #f0f0f0;
    text-align: center;
    .el-dialog__title {
      font-size: 18px;
      color: #333;
      font-weight: normal;
    }
  }
  .el-dialog__body {
    padding: 20px 40px;
    .el-form-item__content {
      line-height: 1;
    }
    .producr-select {
      width: 450px;
      height: 36px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #aaa;
      ::-webkit-input-placeholder { /* WebKit browsers */
        color:#aaa;
      }
      :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        color:#aaa;
      }
      ::-moz-placeholder { /* Mozilla Firefox 19+ */
        color:#aaa;
      }
      :-ms-input-placeholder { /* Internet Explorer 10+ */
        color:#aaa;
      }
    }
    .bottom-btns {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      button {
        width: 200px;
        height: 40px;
      }
      .cancel-button {
        border: 1px solid #e3e3e3;
        color: #777;
      }
    }
  }
}
}

.el-select-dropdown {
  .el-select-dropdown__item {
    white-space: normal;
    height: auto;
    width: 450px;
  }
}

/deep/ .has-error .el-form-item__label {
  color: rgb(72, 84, 106);
}

</style>



// WEBPACK FOOTER //
// src/pages/orders/fliggy-order-detail/modals/bind-product.vue